import { Box, Text } from "@chakra-ui/react";

type Props = { steps: readonly string[]; current: number; label: string };

const WizardStepper = ({ steps, current, label }: Props): JSX.Element => (
  <Box display="flex" gap="1" overflowX="auto" pb="1" aria-label={label}>
    {steps.map((label, index) => (
      <Box
        key={label}
        flex="1 0 auto"
        minW="104px"
        display="flex"
        flexDirection="column"
        gap="1.5"
        aria-current={index === current ? "step" : undefined}
      >
        <Box
          h="1"
          borderRadius="full"
          bg={index <= current ? "palomma.500" : "gray.200"}
        />
        <Text
          fontSize="xs"
          fontWeight="semibold"
          color={index === current ? "gray.800" : "gray.400"}
        >
          {index + 1}. {label}
        </Text>
      </Box>
    ))}
  </Box>
);

export default WizardStepper;
